// extracted by mini-css-extract-plugin
export default {"NavigationItem":"NavigationItem_NavigationItem__G4VoL","Sidedraw":"NavigationItem_Sidedraw__y69w8"};